<template>
  <BaseButton @click="buttonAction">
    <template v-if="loading">
      <beat-loader class="text-xs" size="12px" color="white" />
    </template>
    <template v-else>
      <slot />
    </template>
  </BaseButton>
</template>

<script>
import BeatLoader from 'vue-spinner/src/BeatLoader.vue'

export default {
  components: { BeatLoader },

  props: {
    loading: {
      type: Boolean,
    },
    action: {
      type: Function,
      required: false,
      default: null,
    },
  },

  methods: {
    buttonAction(e) {
      if (this.action) {
        e.preventDefault()
        this.action()
      }
    },
  },
}
</script>
